import { createFileRoute } from '@tanstack/react-router';

import { filtrosMisIncidenciasSchema } from '@/entities/incidencia';
import { exigirAcceso } from '@/entities/usuario';
import { IncidenciasListPage } from '@/pages/incidencias-list';

export const Route = createFileRoute('/_private/incidencias')({
  validateSearch: filtrosMisIncidenciasSchema,
  beforeLoad: () => exigirAcceso('incidencias'),
  component: IncidenciasListPage,
});
